import ConfirmPopup from '~/components/shared/ConfirmPopup';
import { PostingType } from '~/enums/PostingType';
import WarningIcon from '~/images/icons/Warning';
import { Colors } from '~/themes/colors';

interface IOverlappingJobPopup {
  isOpen: boolean;
  jobPostingType?: PostingType;
  onConfirm?: () => void;
  onGoBack?: () => void;
}

export const OverlappingJobPopup = ({
  isOpen,
  jobPostingType = PostingType.TempShift,
  onConfirm,
  onGoBack,
}: IOverlappingJobPopup) => {
  if (!isOpen) {
    return null;
  }

  return (
    // @ts-expect-error - Confirm Popup still written in JavaScript
    <ConfirmPopup
      Icon={() => (
        <div style={{ marginBottom: 20 }}>
          <WarningIcon width={64} height={64} />
        </div>
      )}
      title="Please Confirm"
      description={`At least 1 ${jobPostingType === PostingType.TempShift ? 'shift' : 'interview'} overlaps with an existing opportunity posted and/or confirmed. If you would like to review the dates, click "Go Back". If you wish to continue, click on "Confirm".`}
      descriptionStyle={{ width: '76%', marginBottom: 50 }}
      leftButtonText="Go Back"
      leftButtonStyle={{
        backgroundColor: Colors.secondary_500,
      }}
      leftButtonAction={onGoBack}
      rightButtonText="Confirm"
      rightButtonAction={onConfirm}
    />
  );
};
